<script>
  // import api from '@/utils/api'
  import axios from 'axios'
  import * as dtUtils from '@/utils/datetime'
  import NewMaterialItemList from '@/components/new-material-item-list.vue'
  import PageHeader from '@/components/page-header.vue'
  export default {
    name: 'new-materials',
    components: {
      NewMaterialItemList,
      PageHeader
    },
    data: () => ({
      categories: [],
      categoryMap: {
        new_audiobooks: {
          icon: 'mdi-book-music'
        },
        new_bluray: {
          icon: 'mdi-video-high-definition'
        },
        new_dvds: {
          icon: 'mdi-video'
        },
        new_fiction: {
          icon: 'mdi-book'
        },
        new_musiccds: {
          icon: 'mdi-music-circle'
        },
        new_nonfiction: {
          icon: 'mdi-book-information-variant'
        },
        new_ya: {
          icon: 'mdi-book-education'
        }
      },
      categorySelected: null,
      error: null,
      isLoading: false,
      items: {}
    }),
    computed: {
      month() {
        if (!this.items?.[this.categorySelected]) return ''
        const lastItem = [...this.items[this.categorySelected]].sort((a, b) => b?.dateAdded - a?.dateAdded)[0]
        return dtUtils.monthFromDate(lastItem.dateAdded)
      }
    },
    methods: {
      itemImage(item) {
        return item?.imageLinks?.thumbnail || ''
      },
      async onCategoryChange(slug = '') {
        if (!slug) {
          this.error = 'Select a category above to see its latest arrivals.'
        }
        if (this.$route?.params?.category !== slug) {
          this.$router.push({
            name: 'new-material',
            params: {
              category: slug || null
            }
          })
        }
        const category = this.categories.find(c => c.slug === slug)
        if (!category) {
          console.log('category not found, set error here')
          this.categorySelected = null
          this.isLoading = false
          return
        }
        this.categorySelected = slug
        if (!this.items[category.slug]) {
          this.isLoading = true
          const res = await this.tempFetch(category.slug)
          this.items[category.slug] = res[0]?.items || []
          this.isLoading = false
        }
      },
      async tempFetch(param) {
        const url = `https://old.eipl.org/api/index.php/org/new_materials/${param}`
        // const url = 'https://eipl.org/api/index.php/org/new_materials_get/sample'
        const withCredentials = true
        const res = await axios(url, {
          credentials: 'include',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          mode: 'no-cors',
          method: 'GET',
          url,
          withCredentials
        })
        if (res?.data) return res.data
      }
    },
    async created() {
      //TODO: create getCategories()
      console.log('CREATED ______ ')
      const resp = await this.tempFetch('categories')
      if (resp) {
        this.categories = Object.values(resp).map(cat => {
          return {
            ...cat,
            ...this.categoryMap?.[cat.key],
            label: cat.category || ''
          }
        })
      }
      if (this.$route?.params?.category) {
        this.categorySelected = this.$route.params.category
        this.onCategoryChange(this.$route.params.category)
      }
      // TODO: SETUP NEW API ENDPOINT
      // const endpoint = `new-material`
      // api.get(endpoint).then(response => {
      //   console.log(response)
      //   this.isLoading = false
      // })
    },
    watch: {
      async '$route.params.category'(e) {
        const cat = this?.categories?.find(c => c.slug === e)
        if (cat?.slug) {
          await this.onCategoryChange(e)
        }
      }
    }
  }
</script>
<template>
  <v-container class="main-container">
    <page-header
      v-model="categorySelected"
      backgroundColor="#00bcd4"
      :chipItems="$route?.params?.category && categories?.length ? categories : []"
      titleText="LATEST ARRIVALS"
      :titleColor="$vuetify.theme.themes.light.secondary"
      @input="onCategoryChange"
    ></page-header>
    <v-row align="center" justify="center">
      <template v-if="!$route?.params?.category || (!categorySelected && categories?.length)">
        <v-col v-for="cat in categories" :key="cat.key" cols="11" md="5">
          <v-card hover @click="onCategoryChange(cat.slug)"
            ><v-card-text class="d-flex align-center font-weight-bold text-h6" style="color: #00bcd4">
              <v-icon color="#00bcd4" x-large class="mr-4">mdi {{ cat.icon }}</v-icon> {{ cat.label }}</v-card-text
            ></v-card
          >
        </v-col>
        <v-col cols="12" sm="5" />
        <!-- dummy col for alignment -->
      </template>

      <v-col cols="12" md="10" lg="8" xl="6">
        <v-sheet v-if="isLoading" color="transparent" class="d-flex flex-column align-center justify-center">
          <p class="text-center primary--text font-weight-bold">Getting items...</p>
          <v-progress-circular indeterminate color="primary" />
        </v-sheet>
        <v-sheet v-else-if="error" color="transparent" width="auto" class="d-flex flex-column align-center justify-center rounded-lg">
          <p class="d-span text-center error--text font-weight-bold secondary rounded-pill py-4 px-8">{{ error }}</p>
        </v-sheet>
        <template v-else-if="categorySelected && $route?.params?.category">
          <v-sheet color="transparent" width="100%" class="d-flex align-center justify-center">
            <h2 class="text-h4 secondary--text font-weight-bold text-left pl-4 pl-lg-0" style="max-width: 1200px; width: 100%">{{ month }}</h2>
          </v-sheet>
          <new-material-item-list :items="items?.[categorySelected] || []"></new-material-item-list>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>
<style scoped>
  .main-container {
    --background: #00bcd4;
    background-color: var(--background);
  }
</style>
